import React from 'react';

export default function SearchIcon() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.2549 11.255H12.4649L12.1849 10.985C13.1649 9.845 13.7549 8.365 13.7549 6.755C13.7549 3.165 10.8449 0.255005 7.25488 0.255005C3.66488 0.255005 0.754883 3.165 0.754883 6.755C0.754883 10.345 3.66488 13.255 7.25488 13.255C8.86488 13.255 10.3449 12.665 11.4849 11.685L11.7549 11.965V12.755L16.7549 17.745L18.2449 16.255L13.2549 11.255ZM7.25488 11.255C4.76488 11.255 2.75488 9.245 2.75488 6.755C2.75488 4.26501 4.76488 2.255 7.25488 2.255C9.74488 2.255 11.7549 4.26501 11.7549 6.755C11.7549 9.245 9.74488 11.255 7.25488 11.255Z" />
    </svg>
  );
}
